import * as React from 'react'
import styled from 'styled-components'

const Scrollable: React.ComponentType<{}> = styled.div`
  max-height: 500px;
  overflow: auto;
`

export default Scrollable
